export default __webpack_public_path__ + "static/media/user.dc6e1254.svg";